import AccountDetailsCheckboxInput from './AccountDetailsCheckboxInput'

export default AccountDetailsCheckboxInput